import { render } from "./LeadsActiveList.vue?vue&type=template&id=2698ab7a"
import script from "./LeadsActiveList.vue?vue&type=script&lang=js"
export * from "./LeadsActiveList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__